module.exports = __webpack_public_path__ + "static/img/drop_outline_989EA3.09ab571a.svg";